import axios, { AxiosResponse } from 'axios';
import { RazorPayCreateOrderApiRequest, RazorPayVerifyPayment } from 'types/request';

const iAxios = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

export const createRazorPayOrder = async (
  data: RazorPayCreateOrderApiRequest
): Promise<
  AxiosResponse<{
    orderId: string;
    amount: string;
    enrollMentId: string;
  }>
> => {
  return await iAxios.post('/razorpay/create-order', {
    fullName: data.fullName,
    email: data.email,
    whatsappNumber: data.whatsappNumber,
    amount: data.amount,
    program: data.program,
    referredBy: data.referredBy,
  });
};

export const verifyPayment = async (data: RazorPayVerifyPayment) => {
  return await iAxios.post('/razorpay/verify-payment', data);
};
